<div class="outer-container">
   <div class="pageHeader-row">
      <div class="pageHeader-text">
         <div class="pre-heading">{{ reviewType == "OPEN" ? "OPEN CYCLE" : getRevieweeLabel() }}</div>
         <div class="heading">Performance Hub</div>
         <div class="subtext">
            Select a {{ reviewType == "OPEN" ? "user" : getRevieweeLabel() }} from the list below to begin their performance review.
         </div>
      </div>

      <div class="pageHeader-filters">
         <button
            type="button"
            class="v-button v-button-md v-green mr-1"
            style="height: 43px; font-size: 16px"
            (click)="openExportModal()"
            alt="Export List"
            title="Export List">
            <i class="fa fa-arrow-up-from-bracket"></i>
         </button>

         <vc-single-select-dropdown
            class="mr-1 dvm-drop"
            [items]="practiceOptions"
            [optionLabel]="'label'"
            [optionValue]="'value'"
            variantClass="v-sitefilter"
            sizeClass="v-dropdown-sm"
            [placeholder]="'Filter by Hospital'"
            [disabled]="reviewType == 'DO' || reviewType == 'RM' ? true : false"
            [filter]="true"
            [setValue]="selectedPractice"
            (selectionChange)="onPracticeChange($event)"></vc-single-select-dropdown>

         <vc-single-select-dropdown
            *ngIf="reviewType != 'DVM' && reviewType != 'COS' && reviewType != 'OPEN'"
            class="mr-1 dvm-drop"
            [items]="reviewerNameOptions"
            [optionLabel]="'label'"
            [optionValue]="'value'"
            variantClass="v-userfilter"
            sizeClass="v-dropdown-sm"
            [placeholder]="'Filter by ' + getReviewerLabel(true)"
            [filter]="true"
            [setValue]="selectedReviewerName"
            (selectionChange)="onReviewerChange($event)"></vc-single-select-dropdown>

         <vc-single-select-dropdown
            *ngIf="reviewType == 'DVM' || reviewType == 'COS' || reviewType == 'OPEN'"
            class="mr-1 dvm-drop"
            [items]="rmOptions"
            [optionLabel]="'label'"
            [optionValue]="'value'"
            variantClass="v-userfilter"
            sizeClass="v-dropdown-sm"
            [placeholder]="'Filter by RM'"
            [filter]="true"
            [setValue]="selectedRMName"
            (selectionChange)="onRMChange($event)"></vc-single-select-dropdown>

         <div class="v-searchbox-sm v-userfilter mr-1">
            <vc-text-input
               type="text"
               (ngModelChange)="onNameSearch($event)"
               [(ngModel)]="searchName"
               placeholder="Search by name..."></vc-text-input>
         </div>

         <vc-single-select-dropdown
            class="dvm-drop allStatus-drop"
            [items]="statusOptions"
            [optionLabel]="'label'"
            [optionValue]="'value'"
            variantClass="none"
            sizeClass="v-dropdown-xs"
            [placeholder]="'Status: Show all'"
            [filter]="false"
            [showClear]="false"
            [setValue]="selectedStatus"
            (selectionChange)="onStatusChange($event)"></vc-single-select-dropdown>
      </div>

      <div class="chips-row">
         <span class="chips-label">{{ getRevieweeLabel(false) + "s " }}</span>
         <mat-chip-listbox
            multiple
            [(ngModel)]="selectedDeferredFilters"
            (change)="onDeferredChipChange($event)">
            <mat-chip-option value="null">Show All</mat-chip-option>
            <mat-chip-option value="active">Active</mat-chip-option>
            <mat-chip-option value="deferred">Deferred</mat-chip-option>
            <mat-chip-option value="LOAINACTIVE">On Leave</mat-chip-option>
         </mat-chip-listbox>
      </div>
   </div>

   <!-- Cycle closed notice -->
   <div
      *ngIf="!isCurrentCycleOpen"
      class="cycle-closed-notice">
      <i class="fa fa-lock cycle-closed-notice__icon"></i>
      <div class="cycle-closed-notice__body">
         <span class="cycle-closed-notice__title">
            {{ reviewType === "DVM" ? selectedCycle : reviewType }} performance reviews are currently closed -
         </span>
         <span class="cycle-closed-notice__reason">{{ currentCycleClosedReason }}</span>
      </div>
   </div>

   <!-- Quarter cycle tabs for aDVM's -->
   <div
      *ngIf="reviewType == 'DVM'"
      class="cycle-tabs-row">
      <ng-container *ngFor="let tab of cycleTabViews">
         <button
            *ngIf="tab.enabled"
            class="cycle-tab"
            [class.button-inactive]="!tab.enabled"
            [class.cycle-tab--active]="selectedCycle === tab.cycle"
            (click)="onCycleChange(tab.cycle)"
            [title]="tab.closedReason">
            <i
               class="fa fa-calendar-days"
               style="font-size: 16px"></i>

            {{ tab.cycle }}

            <small
               *ngIf="tab.open"
               class="cycle-tab-badge c-active">
               Active
            </small>

            <span
               *ngIf="!tab.open"
               class="cycle-tab-badge">
               Closed
            </span>
         </button>
      </ng-container>
   </div>

   <div class="main-app-container">
      <vc-spinner *ngIf="!isUserReviewsLoaded || !isPlansLoaded"></vc-spinner>
      <div
         *ngIf="isUserReviewsLoaded && isPlansLoaded"
         class="table-container"
         [class.table-container--read-only]="!isCurrentCycleOpen">
         <table
            matSort
            (matSortChange)="sortData($event)">
            <thead>
               <tr class="columnHeaders">
                  <th
                     mat-sort-header="reviewType"
                     style="padding-left: 44px; font-size: 11px; font-style: italic; line-height: 15px; text-align: center"
                     *ngIf="reviewType == 'OPEN'">
                     Initial
                     <br />
                     Cycle
                  </th>
                  <th mat-sort-header="name">
                     {{ reviewType == "OPEN" ? "Reviewee" : getRevieweeLabel() }}
                  </th>
                  <th
                     mat-sort-header="practice"
                     style="max-width: 300px">
                     Hospital
                  </th>
                  <th mat-sort-header="dvmSubmittedOn">{{ reviewType == "OPEN" ? "Reviewee" : getRevieweeLabel(true) }} Submitted</th>
                  <th mat-sort-header="cosSubmittedOn">
                     {{ reviewType == "OPEN" ? "Reviewer" : getReviewerLabel(true) }}{{ reviewType == "COS" ? "/RM" : "" }} Submitted
                  </th>
                  <th [mat-sort-header]="reviewType == 'RM' ? 'directorName' : (getReviewerLabel(true) | lowercase) + 'Name'">
                     {{ getReviewerLabel(true) }}
                  </th>
                  <th
                     *ngIf="reviewType == 'HM' || reviewType == 'DVM'"
                     mat-sort-header="cosaName">
                     COSA
                  </th>
                  <th
                     *ngIf="reviewType == 'DVM' || reviewType == 'COS'"
                     mat-sort-header="rmName">
                     RM
                  </th>
                  <th
                     mat-sort-header="status"
                     style="min-width: 70px">
                     Status
                  </th>
                  <th
                     *ngIf="reviewType == 'OPEN'"
                     style="padding-right: 5px; width: 115px"
                     mat-sort-header="whenCompletedBy">
                     When to Complete
                  </th>
                  <th class="defer-col-header">{{ isReportingAdmin() ? "" : "Deferred" }}</th>
               </tr>
            </thead>
            <tbody>
               <tr *ngIf="dashboardRows.length < 1">
                  <td
                     colspan="9"
                     style="text-align: center">
                     You have no {{ getRevieweeLabel() }}s to review
                  </td>
               </tr>

               <tr
                  *ngFor="let row of pagedRows; let i = index; trackBy: trackByReviewee"
                  [class.alternate]="i % 2 !== 0"
                  [class.row-deferred]="(row._deferred || row._onLeave) && reviewType != 'OPEN'"
                  [class.row-read-only]="readOnlyMode"
                  (click)="onRowClick(row)"
                  style="vertical-align: -webkit-baseline-middle">
                  <td
                     class="open-review-col"
                     *ngIf="reviewType == 'OPEN'">
                     {{ row.reviewType }}
                  </td>
                  <td style="text-wrap-mode: nowrap">
                     <a
                        class="review-row-link"
                        style="color: #55585a"
                        [routerLink]="['/performance-hub/reviews', row.revieweeId]"
                        [queryParams]="{ rt: reviewType == 'OPEN' ? row.reviewType : reviewType, from: reviewType }"
                        (click)="$event.stopPropagation()">
                        {{ row.name }}
                        <span *ngIf="row.hasAttachment">
                           &nbsp;
                           <i
                              class="fa fa-paperclip"
                              style="font-size: 12px; color: #505050"></i>
                        </span>

                        <span
                           *ngIf="row._deferred"
                           class="deferred-badge"
                           tooltipstyleclass="pims-tooltip"
                           [pTooltip]="row.deferReason"
                           style="padding-bottom: 1px">
                           <i class="fa fa-clock"></i>
                           Deferred
                        </span>
                        <span
                           *ngIf="row._onLeave"
                           class="deferred-badge">
                           <i class="fa fa-user-alt"></i>
                           On leave
                        </span>
                     </a>
                  </td>

                  <td style="max-width: 250px; min-width: 175px">{{ row.practice ? row.practice : "---" }}</td>

                  <td style="padding-right: 5px; width: 130px">
                     <span [class.incomplete-status-badge]="row._dvmIncomplete">
                        {{ row.dvmSubmittedOn || "INCOMPLETE" }}
                     </span>
                  </td>
                  <td style="padding-right: 5px; width: 130px">
                     <span [class.incomplete-status-badge]="row._cosIncomplete">
                        {{ row.cosSubmittedOn || "INCOMPLETE" }}
                     </span>
                  </td>

                  <td style="padding-right: 5px; min-width: 125px">
                     {{ row._reviewerName }}
                     <span
                        *ngIf="row._newReviewerName && row._newReviewerName != row._newReviewerName"
                        style="padding-top: 2px; display: block; color: #959595; font-size: 11px; line-height: 14px">
                        <i
                           class="fa fa-arrow-turn-up"
                           style="transform: rotate(90deg)"></i>
                        &nbsp;Other: {{ row._newReviewerName }}
                     </span>
                  </td>

                  <td
                     *ngIf="reviewType == 'HM' || reviewType == 'DVM'"
                     style="min-width: 125px; padding-right: 5px">
                     {{ row.vetLeaderName }}
                     <span
                        *ngIf="row.newCOSA && row.newCOSA != row.vetLeaderName"
                        style="padding-top: 2px; display: block; color: #959595; font-size: 11px; line-height: 14px">
                        <i
                           class="fa fa-arrow-turn-up"
                           style="transform: rotate(90deg)"></i>
                        &nbsp;Other: {{ row.newCOSA }}
                     </span>
                  </td>

                  <td
                     *ngIf="reviewType == 'DVM' || reviewType == 'COS'"
                     style="min-width: 125px; padding-right: 5px">
                     {{ row.rmName }}
                     <span
                        *ngIf="row.newRM && row.newRM != row.rmName"
                        style="padding-top: 2px; display: block; color: #959595; font-size: 11px; line-height: 14px">
                        <i
                           class="fa fa-arrow-turn-up"
                           style="transform: rotate(90deg)"></i>
                        &nbsp;Other: {{ row.newRM }}
                     </span>
                  </td>

                  <td style="min-width: 145px; padding-right: 5px">
                     <span
                        class="status-badge"
                        [class]="
                           row.isCompleted
                              ? 'status-complete'
                              : row.dvmSubmittedOn && row.cosSubmittedOn
                                ? 'status-in-review'
                                : !row.dvmSubmittedOn && !row.cosSubmittedOn && !row.hasStarted
                                  ? 'status-not-started'
                                  : 'status-pending'
                        ">
                        <i
                           [class]="
                              row.isCompleted
                                 ? 'fa fa-check-circle completed-icon'
                                 : row.dvmSubmittedOn && row.cosSubmittedOn
                                   ? 'fa fa-user-group pending-icon'
                                   : !row.dvmSubmittedOn && !row.cosSubmittedOn && !row.hasStarted
                                     ? 'fa fa-circle-minus'
                                     : 'fa fa-hourglass-half in-progress-icon'
                           "></i>
                        {{
                           row.isCompleted
                              ? "Completed"
                              : row.dvmSubmittedOn && row.cosSubmittedOn
                                ? "In Review"
                                : !row.dvmSubmittedOn && !row.cosSubmittedOn && !row.hasStarted
                                  ? "Not Started"
                                  : "In Progress"
                        }}
                     </span>
                  </td>

                  <td
                     *ngIf="reviewType == 'OPEN'"
                     style="padding-right: 5px; width: 115px">
                     {{ row.whenCompletedBy ? row.whenCompletedBy : row.whenOpenCompletedBy }}
                  </td>

                  <!--<td
                     style="min-width: 155px"
                     *ngIf="isReportingAdmin()"
                     class="defer-col"
                     (click)="$event.stopPropagation()">
                     <button
                        *ngIf="
                           !row.isCompleted &&
                           !row._deferred &&
                           (!row.deferralStatus || row.deferralStatus == 'ReEnabled' || row.deferralStatus == 'Rejected')
                        "
                        class="defer-btn"
                        (click)="openDeferDialog(row)">
                        Defer User
                     </button>

                     <button
                        *ngIf="!row.isCompleted && (row.hasPendingDeferralRequest || row.deferralStatus == 'Pending')"
                        class="defer-btn"
                        [class.defer-btn-requested]="row.hasPendingDeferralRequest || row.deferralStatus == 'Pending'"
                        [disabled]="row.hasPendingDeferralRequest || row.deferralStatus == 'Pending'">
                        <i
                           class="fa fa-hourglass"
                           style="font-size: 11px; line-height: 18px"></i>
                        &nbsp; Pending
                     </button>

                     <ng-container *ngIf="!row.isCompleted && row._deferred">
                        <button
                           class="defer-btn defer-btn-active"
                           (click)="adminReEnableUser(row)">
                           <i
                              class="fa fa-dot-circle"
                              style="font-size: 11px; line-height: 18px"></i>
                           &nbsp; Re-enable
                        </button>
                     </ng-container>
                     <span
                        *ngIf="row.isCompleted"
                        class="defer-na"
                        style="padding-right: 10px">
                        —
                     </span>
                  </td>-->

                  <td
                     style="min-width: 65px"
                     *ngIf="isReportingAdmin()"
                     class="defer-col"
                     (click)="$event.stopPropagation()">
                     <a
                        class="settings-nav-btn"
                        title="Manage user settings"
                        style="vertical-align: middle"
                        [href]="'./performance-hub/admin/user-management?userId=' + row.revieweeId + '&revieweeDisplayName=' + row.name + ''"
                        rel="noopener"
                        target="_blank">
                        <i class="fa fa-gear"></i>
                     </a>
                  </td>

                  <td
                     style="min-width: 155px; padding-left: 5px"
                     class="defer-col"
                     *ngIf="!isReportingAdmin()"
                     (click)="$event.stopPropagation()">
                     <!-- No deferral yet: show Request Deferral button -->
                     <button
                        *ngIf="!row.deferralStatus || row.deferralStatus == 'ReEnabled' || row.deferralStatus == 'Rejected'"
                        class="defer-btn"
                        style="position: relative"
                        [class.defer-btn-rejected]="row.deferralStatus == 'Rejected'"
                        (click)="row.deferralStatus == 'Rejected' ? openRejectedDialog(row) : openUserDeferDialog(row)">
                        <i
                           *ngIf="row.deferralStatus == 'Rejected'"
                           class="fa fa-close"
                           style="margin-right: 5px; margin-top: 2px"></i>
                        {{ row.deferralStatus == "Rejected" ? "Rejected" : "Request Deferral" }}
                        <span
                           *ngIf="row.deferralStatus == 'Rejected'"
                           class="fu-unread-badge">
                           1
                        </span>
                     </button>

                     <a
                        href="javascript:void(0);"
                        *ngIf="row.deferralStatus == 'Rejected'"
                        style="display: block; text-decoration: underline; font-size: 11px; color: #333333"
                        (click)="openUserDeferDialog(row)">
                        Request again?
                     </a>

                     <!-- Pending + no admin follow-up: show Requested (disabled) -->
                     <button
                        *ngIf="(row.hasPendingDeferralRequest || row.deferralStatus == 'Pending') && (!row.hasAdminFollowUp || row._unread < 1)"
                        class="defer-btn defer-btn-requested"
                        [disabled]="true">
                        <i
                           class="fa fa-hourglass"
                           style="font-size: 11px; line-height: 18px"></i>
                        &nbsp; Requested
                     </button>

                     <!-- Pending + admin replied: show Follow-up required (clickable) -->
                     <button
                        *ngIf="(row.hasPendingDeferralRequest || row.deferralStatus == 'Pending') && row.hasAdminFollowUp && row._unread > 0"
                        class="defer-btn defer-btn-followup"
                        style="position: relative"
                        (click)="openUserFollowUpDialog(row)">
                        <i
                           class="fa fa-comments"
                           style="font-size: 11px; line-height: 18px"></i>
                        &nbsp; Add Follow-up
                        <span
                           *ngIf="row._unread > 0"
                           class="fu-unread-badge">
                           {{ row._unread }}
                        </span>
                     </button>

                     <!-- Approved or Deferred: show dash -->
                     <span
                        *ngIf="row.deferralStatus == 'Approved' || row.deferralStatus == 'Deferred'"
                        class="defer-na">
                        —
                     </span>
                  </td>
               </tr>
            </tbody>
         </table>

         <!-- Pager -->
         <div
            class="table-pager"
            *ngIf="dashboardRows.length > pageSize">
            <button
               type="button"
               class="table-pager__btn"
               [disabled]="pageIndex === 0"
               (click)="goToPage(0)"
               title="First page">
               <i class="fa fa-angles-left"></i>
            </button>
            <button
               type="button"
               class="table-pager__btn"
               [disabled]="pageIndex === 0"
               (click)="goToPage(pageIndex - 1)"
               title="Previous page">
               <i class="fa fa-angle-left"></i>
            </button>
            <span class="table-pager__label">
               Page
               <input
                  type="number"
                  class="table-pager__input"
                  [value]="pageIndex + 1"
                  [min]="1"
                  [max]="totalPages"
                  (change)="goToPage(+$event.target.value - 1)" />
               of {{ totalPages }} · {{ pageRangeStart }}–{{ pageRangeEnd }} of {{ dashboardRows.length }}
            </span>
            <button
               type="button"
               class="table-pager__btn"
               [disabled]="pageIndex >= totalPages - 1"
               (click)="goToPage(pageIndex + 1)"
               title="Next page">
               <i class="fa fa-angle-right"></i>
            </button>
            <button
               type="button"
               class="table-pager__btn"
               [disabled]="pageIndex >= totalPages - 1"
               (click)="goToPage(totalPages - 1)"
               title="Last page">
               <i class="fa fa-angles-right"></i>
            </button>
         </div>
      </div>
   </div>
</div>

<ng-container *ngIf="userDeferDialog().show">
   <div
      class="defer-overlay"
      (click)="closeUserDeferDialog()">
      <div
         class="defer-dialog"
         (click)="$event.stopPropagation()">
         <div class="defer-modal-title">Request a deferral</div>
         <p class="defer-modal-subtitle">
            <span *ngIf="!isAutoApprovedDeferral">
               This request will be sent to an admin for review. Your team member will not be deferred until it is approved.
            </span>
            <span *ngIf="isAutoApprovedDeferral">
               This deferral is approved on submit. The review moves out of its current type and into the Open Cycle.
            </span>
         </p>

         <p class="defer-prompt">Reason Category</p>
         <div
            class="defer-category-trigger"
            [class.open]="deferCategoryOpen"
            (click)="deferCategoryOpen = !deferCategoryOpen">
            <span
               *ngIf="!deferReasonCategory"
               class="defer-category-placeholder">
               Select a reason…
            </span>
            <span
               *ngIf="deferReasonCategory"
               class="defer-category-selected">
               {{ deferReasonCategory }}
            </span>
            <i
               class="fa fa-chevron-down defer-category-chevron"
               [class.rotated]="deferCategoryOpen"></i>
         </div>

         <div
            class="defer-category-dropdown"
            *ngIf="deferCategoryOpen">
            <div
               *ngFor="let opt of deferCategoryOptions"
               class="defer-category-option"
               [class.selected]="deferReasonCategory === opt.label"
               (click)="selectDeferCategory(opt.label)">
               <div class="defer-category-option-title">{{ opt.label }}</div>
               <div class="defer-category-option-desc">{{ opt.description }}</div>
            </div>
         </div>

         <p
            class="defer-prompt"
            [style.opacity]="(!needsAdminApproval && !canSelectDeferQuarter) || deferQuarter == '1 Year' ? '0.4' : '1'">
            When Should This Review be Completed?
         </p>

         <div class="defer-quarter-strip">
            <div
               [class.disabled]="!needsAdminApproval"
               class="defer-quarter-option"
               [class.selected]="!deferQuarter"
               (click)="selectDeferQuarter(null)">
               <div class="defer-quarter-label">Needs Admin Review</div>
            </div>
            <div
               *ngFor="let q of deferQuarterOptions"
               class="defer-quarter-option"
               [class.selected]="deferQuarter === q.value"
               [class.disabled]="!canSelectDeferQuarter || deferQuarter == '1 Year'"
               [title]="canSelectDeferQuarter ? '' : 'Available for extended leave of absence or insufficient time under current manager'"
               (click)="selectDeferQuarter(q.value)">
               <div class="defer-quarter-label">{{ q.label }}</div>
               <div class="defer-quarter-sub">{{ q.sub }}</div>
            </div>
         </div>

         <p
            class="defer-prompt"
            style="margin-top: 18px">
            Additional Details
         </p>
         <textarea
            class="defer-textarea"
            [(ngModel)]="deferReason"
            placeholder="Explain why you are requesting a deferral…"
            rows="4"></textarea>

         <div class="defer-footer">
            <p
               class="defer-footer-note"
               [class.auto]="isAutoApprovedDeferral">
               <i
                  class="fa"
                  [class.fa-bolt]="isAutoApprovedDeferral"
                  [class.fa-user]="!isAutoApprovedDeferral"></i>
               <span *ngIf="isAutoApprovedDeferral">Auto-approves and moves the review to Open Cycle</span>
               <span *ngIf="!isAutoApprovedDeferral">An admin will review this request</span>
            </p>
            <div class="defer-footer-buttons">
               <button
                  class="v-button v-button-md v-white"
                  (click)="closeUserDeferDialog()"
                  [disabled]="isSubmittingUpdate">
                  Cancel
               </button>
               <button
                  class="v-button v-button-md v-green"
                  (click)="onUserDeferSubmit()"
                  [disabled]="!deferReasonCategory || !deferReason?.trim() || isSubmittingUpdate">
                  <span *ngIf="!isSubmittingUpdate">Submit Request</span>
                  <span
                     *ngIf="isSubmittingUpdate"
                     class="spinnerSave"></span>
               </button>
            </div>
         </div>
      </div>
   </div>
</ng-container>

<!-- User follow-up dialog -->
<div
   class="um-dialog-backdrop"
   *ngIf="userFollowUpDialog().show"
   (click)="closeUserFollowUpDialog()"></div>
<div
   class="um-dialog fu-dialog"
   *ngIf="userFollowUpDialog().show">
   <div class="fu-header">
      <div class="fu-header-info">
         <div class="fu-title">Follow-up for {{ userFollowUpDialog().row?.name }}</div>
         <div class="fu-subtitle">{{ userFollowUpDialog().row?.practice }}</div>
      </div>
      <button
         class="rp-modal-close"
         (click)="closeUserFollowUpDialog()"
         title="Close">
         ✕
      </button>
   </div>

   <div class="fu-body">
      <div
         class="loading"
         *ngIf="userFollowUpLoading">
         Loading messages…
      </div>
      <ng-container *ngIf="!userFollowUpLoading">
         <div class="fu-message fu-message--user">
            <div class="fu-message-avatar fu-message-avatar--user">
               <i class="fa fa-user"></i>
            </div>
            <div class="fu-message-content">
               <div class="fu-message-meta">
                  <span class="fu-message-author">{{ userFollowUpDialog().row?.name }}</span>
                  <span class="fu-message-time">{{ userFollowUpDeferredOn | date: "M/d/yyyy h:mm a" }}</span>
               </div>
               <div class="fu-message-bubble fu-message-bubble--user">
                  {{ userFollowUpDialog().row?.deferReason || "No reason provided." }}
               </div>
            </div>
         </div>

         <div
            *ngFor="let msg of userFollowUpMessages"
            [class]="msg.isAdmin ? 'fu-message fu-message--admin' : 'fu-message fu-message--user-reply'">
            <div [class]="msg.isAdmin ? 'fu-message-avatar fu-message-avatar--admin' : 'fu-message-avatar fu-message-avatar--user'">
               <i [class]="msg.isAdmin ? 'fa fa-hospital-user' : 'fa fa-user'"></i>
            </div>
            <div class="fu-message-content">
               <div class="fu-message-meta">
                  <span class="fu-message-author">Admin</span>
                  <span class="fu-message-time">{{ msg.sentOn | date: "M/d/yyyy h:mm a" }}</span>
               </div>
               <div [class]="msg.isAdmin ? 'fu-message-bubble fu-message-bubble--admin' : 'fu-message-bubble fu-message-bubble--user'">
                  {{ msg.message }}
               </div>
            </div>
         </div>

         <div
            class="fu-empty"
            *ngIf="userFollowUpMessages.length === 0">
            No follow-up messages yet.
         </div>
      </ng-container>
   </div>

   <div class="fu-footer">
      <textarea
         class="fu-textarea"
         [(ngModel)]="userFollowUpMessage"
         placeholder="Write a response…"
         rows="3"></textarea>
      <div class="fu-footer-actions">
         <button
            class="v-button v-button-md v-gray"
            (click)="closeUserFollowUpDialog()">
            Cancel
         </button>
         <button
            class="v-button v-button-md v-teal"
            [disabled]="!userFollowUpMessage?.trim() || userFollowUpSaving"
            (click)="sendUserFollowUp()">
            {{ userFollowUpSaving ? "Sending…" : "Send" }}
         </button>
      </div>
   </div>
</div>

<!-- User reject dialog -->
<div
   class="um-dialog-backdrop"
   *ngIf="rejectedDialog().show"
   (click)="closeRejectedDialog()"></div>
<div
   class="um-dialog fu-dialog"
   style="width: 420px !important"
   *ngIf="rejectedDialog().show">
   <div class="fu-header">
      <div class="fu-header-info">
         <div class="fu-title">
            Deferral Request
            <i>Rejected</i>
         </div>
         <div class="fu-subtitle">Why was the deferral request for {{ rejectedDialog().row?.name }} rejected?</div>
      </div>
      <button
         class="rp-modal-close"
         (click)="closeRejectedDialog()"
         title="Close">
         ✕
      </button>
   </div>

   <div
      class="fu-body"
      style="min-height: unset !important; margin-bottom: 15px">
      <div
         class="fu-message fu-message--admin"
         style="margin-left: 0px">
         <div class="fu-message-content">
            <div class="fu-message-meta">
               <span class="fu-message-author">{{ rejectedDialogResolvedBy }}</span>
               <span class="fu-message-time">{{ rejectedDialogResolvedOn | date: "M/d/yyyy h:mm a" }}</span>
            </div>
            <div class="fu-message-bubble fu-message-bubble--admin">{{ rejectedDialogRejectReason }}</div>
         </div>
      </div>
   </div>
</div>

<!-- Export modal -->
<ng-container *ngIf="exportDialog().show">
   <div
      class="export-overlay"
      (click)="closeExportModal()"></div>

   <div class="export-modal">
      <div class="export-modal__header">
         <div class="export-modal__icon">
            <i class="fa fa-file-excel"></i>
         </div>
         <div class="export-modal__titles">
            <div class="export-modal__title">Export Team List</div>
            <div class="export-modal__subtitle">Choose which columns to include in your Excel export</div>
         </div>
         <button
            type="button"
            class="export-modal__close"
            title="Close"
            (click)="closeExportModal()">
            <i class="fa fa-xmark"></i>
         </button>
      </div>

      <div class="export-modal__toolbar">
         <span class="export-modal__count">
            <strong>{{ selectedExportCount }}</strong>
            of {{ exportColumns.length }} columns selected
         </span>
         <span class="export-modal__toolbar-links">
            <button
               type="button"
               (click)="setAllExportColumns(true)">
               Select all
            </button>
            <span class="export-modal__divider"></span>
            <button
               type="button"
               (click)="setAllExportColumns(false)">
               Clear all
            </button>
         </span>
      </div>

      <div class="export-modal__grid">
         <label
            class="export-col"
            *ngFor="let col of exportColumns"
            [class.export-col--selected]="col.selected">
            <input
               type="checkbox"
               [(ngModel)]="col.selected" />
            <span class="export-col__icon">
               <i
                  class="fa"
                  [ngClass]="col.icon"></i>
            </span>
            <span class="export-col__label">{{ col.label }}</span>
            <span class="export-col__check">
               <i class="fa fa-check"></i>
            </span>
         </label>
      </div>

      <div class="export-modal__footer">
         <button
            type="button"
            class="v-button v-button-md v-white"
            (click)="closeExportModal()">
            Cancel
         </button>
         <button
            type="button"
            class="v-button v-button-md v-green"
            [disabled]="selectedExportCount === 0"
            (click)="exportDashboardRowsXlsx()">
            <i class="fa fa-file-excel"></i>
            &nbsp;Export {{ selectedExportCount }} {{ selectedExportCount === 1 ? "Column" : "Columns" }}
         </button>
      </div>
   </div>
</ng-container>
